/** Staff-facing copy — never "GTIN" in UI. */

export const BARCODE_LABEL = 'Code-barres';
export const BARCODE_SOURCES_LABEL = 'Référentiel codes-barres';
